<template>
  <el-form :model="formData" ref="form" :rules="rules" style="width: 300px">
    <el-form-item prop="minimumVersion" label="Minimum version">
      <el-input style="width: 100px" v-model="formData.minimumVersion" />
    </el-form-item>
    <el-button type="primary" @click="submitForm">Update</el-button>
  </el-form>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { baseApiClient } from "@/utils/api";
import { valid as isValidSemver } from "semver";

export default {
  name: "vscode-extension",
  async mounted() {
    const { data } = await baseApiClient.get(
      "/vscode_extension/minimum_version"
    );
    this.formData.minimumVersion = data.minimum_version;
  },
  data() {
    const validateMinimumVersion = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Please enter the minimum version."));
      } else if (!isValidSemver(value)) {
        callback(new Error("Please enter a value that adheres to semver."));
      } else {
        callback();
      }
    };

    return {
      formData: {
        minimumVersion: "",
      },
      rules: {
        minimumVersion: [
          { required: true, trigger: "blur" },
          { validator: validateMinimumVersion, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async submitForm() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (!valid) {
            return;
          }

          const { token } = localStorage;

          await baseApiClient({
            method: "put",
            url: "/vscode_extension/minimum_version",
            data: {
              minimum_version: this.formData.minimumVersion,
            },
            headers: {
              Authorization: `JWT ${token}`,
            },
          });

          this.$notify.success({
            title: "The minimum version has been updated successfully.",
          });
        });
      } catch (err) {
        return this.$notify.error({
          title: "Failed to update the minimum version.",
        });
      }
    },
  },
};
</script>
